import { render, staticRenderFns } from "./biometricLog.vue?vue&type=template&id=0e239e77&scoped=true&"
import script from "./biometricLog.vue?vue&type=script&lang=js&"
export * from "./biometricLog.vue?vue&type=script&lang=js&"
import style0 from "./biometricLog.vue?vue&type=style&index=0&id=0e239e77&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e239e77",
  null
  
)

export default component.exports